import makeStyles from "@mui/styles/makeStyles";
import { colors } from "@zapalacorp/tokens";

const styles = makeStyles(() => ({
  modalWrapper: {
    maxWidth: 442,
  },
  label: {
    color: colors.gray600,
    margin: 0,
  },
  cancelText: {
    font: "600 14px Manrope",
    letterSpacing: "0.1px",
    color: colors.gray600,
  },
}));

export default styles;
